import router from '../../router/index.js'

const serverUrl = import.meta.env.VITE_SERVER_URL || 'http://localhost:3001'

export const httpRequest = async function(url, { method = 'GET', body }, authentified = false, jsonRequest = false) {
  const headers = new Headers()
  if (body) {
    headers.append('accept', 'application/json')
    headers.append('content-type', 'application/json')
  }
  if (authentified) {
    const token = localStorage.getItem('token')
    if (token) headers.append('authorization', `Bearer ${token}`)
  }
  const init = { method, headers }
  if (body) init.body = JSON.stringify(body);
  let _url = url;
  if (!_url.startsWith(serverUrl)) _url = `${serverUrl}${url}`;
  const res = await fetch(_url, init);

  if (res.status === 401) {
    localStorage.removeItem('token');
    router.push({ name: 'login' });
  } else {
    if (jsonRequest) {
      const json = await res.json();
      if (res.ok) return json;
      else return Promise.reject(json);
    } else return res;
  }
}

export const httpRequestUploadWithProgress = async function(url, { method = 'POST', body }, authentified = true, { onStart, onProgress, onComplete, onError }) {
  let _url = url
  if (!_url.startsWith(serverUrl)) _url = `${serverUrl}${url}`

  const xhr = new XMLHttpRequest()
  xhr.upload.addEventListener('progress', onProgress, false)
  xhr.addEventListener('error', onError, false)
  xhr.addEventListener('loadstart', onStart, false)
  xhr.addEventListener('load', onComplete, false)
  xhr.open(method, _url)
  if (authentified) {
    const token = localStorage.getItem('token')
    xhr.setRequestHeader('authorization', `Bearer ${token}`)
  } 
  xhr.send(body)  
}

export const httpRequestWithProgress = async function(url, { method = 'GET', body }, authentified = false, onProgress) {
  let response
  const headers = new Headers()
  if (authentified) {
    const token = localStorage.getItem('token')
    headers.append('authorization', `Bearer ${token}`)
  }
  const init = { method, headers }
  if (body) init.body = body;
  let _url = url;
  if (!_url.startsWith(serverUrl)) _url = `${serverUrl}${url}`;
  const res = await fetch(_url, init);
  if (res.status === 401) {
    localStorage.removeItem('token');
    router.push({ name: 'login' });
  } else {
    response = res
  }

  const contentLength = +response.headers.get('Content-Length');
  let bytesReceived = 0;
  const reader = response.body.getReader();
  const stream = new ReadableStream({
    async start(controller) {
      // eslint-disable-next-line no-constant-condition
      while (true) {
        const { done, value } = await reader.read();
        if (done) break;
        bytesReceived += value.length;
        onProgress(bytesReceived / contentLength)
        controller.enqueue(value);
      }
      controller.close();
      reader.releaseLock();
    }
  });
  return new Response(stream, { headers: response.headers });
}

export const updateQueryString = function(url, params) {
  let stripHttp = false;
  if (url.substr(0, 4) !== 'http') {
    url = `http://${url}`;
    stripHttp = true;
  }

  const newUrl = Object.entries(params).reduce((url, [key, value]) => {
    if (url.searchParams.get(key) === null) url.searchParams.append(key, value);
    else url.searchParams.set(key, value);
    return url;
  }, new URL(url));

  return stripHttp ? decodeURI(newUrl.toString().substr(7)) : decodeURI(newUrl.toString());
}

export const downloadFile = (url, fileName) => {
  let _url = url;
  if (!_url.startsWith(serverUrl)) _url = `${serverUrl}${url}`;

  const link = document.createElement('a')
  link.href = _url
  link.download = fileName
  link.setAttribute('type', 'hidden')
  link.setAttribute('target', '_blank')
  link.click()
  link.remove()
}
